import React from 'react';
import { Select } from 'antd';
import './footer.less';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const handleSelectChange = (value: string) => {
    // 检查是否是URL（包含域名）
    if (value.startsWith('http://') || value.startsWith('https://') || value.includes('.')) {
      window.open(value, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="custom-footer">
      <div className="footer-top">
        <div className="footer-links">
          <h3 className="links-title">友情链接</h3>
          <Select
            defaultValue="国家部委网站"
            style={{ width: 180, marginRight: 15 }}
            onChange={handleSelectChange}
            options={[
              { value: 'gov1', label: '国家部委网站' },
              { value: 'https://www.miit.gov.cn/', label: '工业和信息化部' },
              { value: 'https://www.mps.gov.cn/', label: '公安部' },
              { value: 'http://www.cac.gov.cn/', label: '国家网信办' },
            ]}
          />
          <Select
            defaultValue="市政府各部门网站"
            style={{ width: 180, marginRight: 15 }}
            onChange={handleSelectChange}
            options={[
              { value: 'city1', label: '市政府各部门网站' },
              { value: 'https://www.beijing.gov.cn/', label: '北京市政府' },
              { value: 'https://jxw.beijing.gov.cn/', label: '北京市经信局' },
              { value: 'https://gaj.beijing.gov.cn/', label: '北京市公安局' },
            ]}
          />
          <Select
            defaultValue="相关协会网站"
            style={{ width: 230 }}
            onChange={handleSelectChange}
            options={[
              { value: 'assoc1', label: '相关协会网站' },
              { value: 'https://www.21csp.com.cn/', label: '中国安全防范产品行业协会' },
              { value: 'https://www.bspia.com.cn/', label: '北京安全防范行业协会' },
            ]}
          />
          <Select
            defaultValue="新闻门户网站"
            style={{ width: 180, marginRight: 15 }}
            onChange={handleSelectChange}
            options={[
              { value: 'news1', label: '新闻网站' },
              { value: 'http://www.xinhuanet.com/', label: '新华网' },
              { value: 'http://www.people.com.cn/', label: '人民网' },
              { value: 'https://www.cctv.com/', label: '央视网' },
            ]}
          />
          
        </div>
        <div className="footer-info">

        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-logo" style={{ textAlign: 'center', marginBottom: '5px' }}>
          <img 
            src="/assets/footer-logo@2x.png" 
            style={{ width: '300px', height: 'auto' }}
          />
        </div>
        <div className="footer-copyright">
          <p>地址：北京市西城区德胜门东滨河路3号 白孔雀艺术世界C座109 | 邮政编码：100120 | 电话：010-62016691</p>
          <p>主办：中关村中安安防产业发展促进会</p>
          <p>© {currentYear} 版权所有：中关村中安安防产业发展促进会 | <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">京ICP备2025131079号-2</a>  </p>
        </div>
        <div className="footer-qr">
          <img src="/assets/qr_2.png?v1" alt="协会二维码" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
